var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(-735 -457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(735 457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-circle-single--circle-geometric-human-person-single-user",
    transform: "translate(735 457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M27.736,13.868A13.868,13.868,0,0,1,13.909,27.736h-.083a13.868,13.868,0,1,1,13.91-13.868ZM22.274,20.8a10.9,10.9,0,0,0-16.811,0,10.9,10.9,0,0,0,16.811,0Zm-8.405-5.944A4.953,4.953,0,1,0,8.915,9.906,4.953,4.953,0,0,0,13.868,14.859Z",
    fill: "#0182f0",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCustomer);
export default __webpack_public_path__ + "static/media/avatar-customer.887eec89e9622fd0aad39309f05a52d6.svg";
export { ForwardRef as ReactComponent };